// @flow

import { Navigate, useLocation } from 'react-router-dom';
import type { To } from 'react-router-dom';

import type { StaticHandlerArgs } from '@gandi/app-runner/server';

type RedirectProps = {
  to: To,
};

/**
 * universal Redirect (browser & SSR)
 */
export function Redirect({
  to,
}: RedirectProps): React$Element<typeof Navigate> {
  const location = useLocation();

  // Preserve search parameters when redirecting
  const target =
    typeof to === 'string'
      ? { pathname: to, search: location.search }
      : { ...to, search: to.search || location.search };

  return <Navigate to={target} replace />;
}

Redirect.handleRedirect = function handleRedirect(
  args: StaticHandlerArgs<RedirectProps>,
): Promise<void> {
  const { to, req, redirect } = args;

  const urlParts = req.url.split('?');
  const currentSearch = urlParts.length > 1 ? `?${urlParts[1]}` : '';

  const targetPath =
    typeof to === 'string'
      ? `${to}${currentSearch}`
      : `${to.pathname || ''}${to.search || currentSearch}${to.hash || ''}`;

  redirect(targetPath);
  return Promise.resolve();
};
